import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';

export default function AccessPage() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [permList, setPermList] = useState([]);
  const [perms, setPerms] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.getUsers().then(setUsers).catch(() => {});
    api.getPermissionsList().then(setPermList).catch(() => {});
  }, []);

  const loadPerms = useCallback(async (userId) => {
    if (!userId) return;
    try {
      const p = await api.getUserPermissions(userId);
      setPerms(p);
    } catch { setPerms({}); }
  }, []);

  function selectUser(userId) {
    setSelectedUser(userId);
    setMsg('');
    loadPerms(userId);
  }

  function toggle(permId) {
    setPerms(prev => ({ ...prev, [permId]: !prev[permId] }));
  }

  function toggleAll(grant) {
    const next = {};
    permList.forEach(p => { next[p.id] = grant; });
    setPerms(next);
  }

  async function save() {
    if (!selectedUser) return;
    setSaving(true);
    try {
      await api.saveUserPermissions(selectedUser, perms);
      setMsg('Доступы сохранены');
    } catch (err) {
      setMsg('Ошибка: ' + err.message);
    }
    setSaving(false);
  }

  const groups = {};
  permList.forEach(p => {
    if (!groups[p.group]) groups[p.group] = [];
    groups[p.group].push(p);
  });

  const selectedName = users.find(u => u.id === selectedUser);

  return (
    <div className="admin-page">
      <h2>Управление доступами</h2>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 24 }}>
        <label style={{ color: 'var(--text2)', fontSize: '0.9rem' }}>Сотрудник:</label>
        <select
          value={selectedUser}
          onChange={e => selectUser(e.target.value)}
          style={{ padding: '10px 14px', background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text)', fontSize: '0.9rem', minWidth: 250 }}
        >
          <option value="">— Выберите сотрудника —</option>
          {users.map(u => (
            <option key={u.id} value={u.id}>
              {u.internal_name} ({u.display_login}){u.role === 'admin' ? ' — админ' : ''}
            </option>
          ))}
        </select>
      </div>

      {selectedUser && (
        <>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <button className="btn-sm" onClick={() => toggleAll(true)}>Выбрать всё</button>
            <button className="btn-sm" onClick={() => toggleAll(false)}>Снять всё</button>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
            {Object.entries(groups).map(([group, items]) => (
              <div key={group} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 16 }}>
                <h4 style={{ color: 'var(--accent)', marginBottom: 12, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: 1 }}>{group}</h4>
                {items.map(p => (
                  <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', cursor: 'pointer', borderBottom: '1px solid var(--border)' }}>
                    <input
                      type="checkbox"
                      checked={!!perms[p.id]}
                      onChange={() => toggle(p.id)}
                      style={{ width: 18, height: 18, accentColor: 'var(--accent)' }}
                    />
                    <span style={{ fontSize: '0.9rem' }}>{p.label}</span>
                  </label>
                ))}
              </div>
            ))}
          </div>

          <div style={{ marginTop: 24, display: 'flex', gap: 12, alignItems: 'center' }}>
            <button className="btn-add" onClick={save} disabled={saving}>
              {saving ? 'Сохранение...' : 'Сохранить доступы'}
            </button>
            {msg && <span style={{ color: msg.startsWith('Ош') ? 'var(--danger)' : 'var(--success)', fontSize: '0.9rem' }}>{msg}</span>}
          </div>

          {selectedName && (
            <div style={{ marginTop: 16, padding: 12, background: 'var(--bg3)', borderRadius: 6, fontSize: '0.85rem', color: 'var(--text2)' }}>
              Настройка доступов для: <strong style={{ color: 'var(--text)' }}>{selectedName.internal_name}</strong>
              {selectedName.role_description && <span> — {selectedName.role_description}</span>}
              {selectedName.role === 'admin' && (
                <div style={{ marginTop: 6 }}>
                  У администратора и так есть доступ ко всем разделам и провайдерам — здесь для него имеет смысл
                  только снимать галочки в группах «Модели ChatGPT/Claude/картинок/видео», чтобы скрыть лишние модели из чата.
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
